/// <reference types="@angular/localize" />

import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { NgbDateAdapter, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { CustomDateAdapter, CustomDateParserFormatter } from './app/shared/date-adapter';

import { provideHttpClient, withInterceptors, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpconfigInterceptor } from './app/interceptors/http-config.interceptor';
import { AuthInterceptor } from './app/interceptors/auth-interceptor.service';

// Registrar locale español para ng-bootstrap
registerLocaleData(localeEs, 'es');

import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppComponent } from './app/app.component';
import { appConfig } from './app.config';
import { APP_CONFIG } from '@mnc/shared-library';
import { environment } from './environments/environment';

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    ...(appConfig.providers || []),
    provideAnimations(),
    provideHttpClient(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpconfigInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    { provide: NgbDateAdapter, useClass: CustomDateAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    {
      provide: APP_CONFIG,
      useValue: environment 
    }
  ],
})
  .catch(err => console.error(err));